<div class="p-3 rounded-3">
  <div class="row mb-2">
    <div class="col-12 mb-3">
      <div class="titletoptables">
        <div class="leftsideicons">
          <img src="../../assets/image/multiple-users.png" alt="img" />
        </div>
        <h3>{{ "Client Details" }}</h3>
      </div>
    </div>

    <div class="row position">
      <div class="col-md-12 kt-margin-bottom-20-mobile" style="display:flex;">
        <div class="col-md-2">
          <div class="srchgrid texttarget">
            <input class="searchtextbox" matInput (keyup)="filterData($any($event.target).value)" [value]="searchString"
              placeholder="Search" autocomplete="off">
            <div class="closeicon" (keydown.enter)="clearList()" (click)="clearList()"> <span
                aria-hidden="true">&times;</span> </div>
          </div>
        </div>
        <div class="col-md-10 toogle">
          <div class="btn-group-offer">

            <button type="button" class="btn btn-primary toogleBtn" [disabled]="IsDisable"
              (click)="add(mailModal)">what's
              new</button>
            <button type="button" class="btn btn-primary toogleBtn" [disabled]="IsDisable"
              (click)="openAllMigrationDialog(null,AllmigrationDialog)">Add
              Migration</button>
            <button type="button" class="btn btn-primary toogleBtn" [disabled]="IsDisable"
              (click)="openMastermigrationDialog(null,MastermigrationDialog)">Add
              Master Migration</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="position">
    <kendo-grid #grid [loading]='kendoLoading' [data]="gridData" [filter]="state.filter" [sortable]="{mode: 'single'}"
      [columnMenu]="{ filter: true }" [pageSize]="state.take" [skip]="state.skip"
      [pageable]="gridData?.data?.length && gridData.data.length > 0 ? pageableWithAll : false"
      (pageChange)="pageChange($event)" [sort]="sort" (sortChange)="gridData ? sortChange($event): null"
      [resizable]="true" [reorderable]="true" filterable="menu" [filter]="state.filter" [selectable]="true"
      (dataStateChange)="gridData ? dataStateChange($event): null" [navigable]="true"
      (selectionChange)="checkboxChecked($event)" (columnVisibilityChange)="onColumnVisibilityChange(grid)"
      [height]="gridHeight">
      <kendo-grid-column title="Action" [width]="65" field='Id' [locked]="true" [sortable]="false" [filterable]="false"
        [columnMenu]="false" [resizable]="false" [reorderable]="false" [groupable]="false">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <button class="verical_menu" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown"
            aria-expanded="false">
            <img src="/assets/image/vertical-icon.png" alt="" class="vertical">
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li style="cursor: pointer;"><a class="dropdown-item"
                (click)="EditClientData(dataItem, EditDialog)">Edit</a></li>
            <li style="cursor:pointer ;"><a class="dropdown-item"
                (click)="openDelateDialog(dataItem, deleteDialog)">Delete</a></li>
            <li style="cursor:pointer ;"><a class="dropdown-item"
                (click)="openMigrationDialog(dataItem, migrationDialog)">Add Migration</a></li>
            <li style="cursor: pointer;"><a class="dropdown-item"
                (click)="openAddOnDialog(dataItem, addOnDialog)">Add-ons</a></li>
            <li style="cursor: pointer;"><a class="dropdown-item"
                (click)="openChangePlanDialog(dataItem, changePlanDialog)">Change Subscription</a></li>
            <li style="cursor: pointer;"><a class="dropdown-item"
                (click)="openWhatsappEnableDialog(dataItem, whatsappDialog)">Enable Whatsapp</a></li>
            <li style="cursor: pointer;"><a class="dropdown-item"
                (click)="openAIAssistantDialog(dataItem, aiAssistantDialog)">Enable AI Assistant</a></li>
            <li style="cursor: pointer;"><a class="dropdown-item" (click)="openResetPasswordDialog(dataItem)">Reset
                Password</a></li>
            <li style="cursor: pointer;"><a class="dropdown-item" (click)="openPlanLimitDialog(dataItem)">Plan Limits
              </a></li>
            <li *ngIf="isRadiologyDomain" style="cursor: pointer;"><a class="dropdown-item"
                (click)="openCreditLimitDialog(dataItem)">Credit limit
              </a></li>
            <li *ngIf="isRadiologyDomain" style="cursor: pointer;"><a class="dropdown-item"
                (click)="openCreditRuleDialog(dataItem)">Credit Rule
              </a></li>
            <li *ngIf="dataItem.IsAutoRenew" style="cursor:pointer ;"><a class="dropdown-item"
                (click)="openCancelAutoRenewDialog(dataItem, autoRenewDialog)">Cancel Auto-Renew</a></li>
            <li style="cursor:pointer;"><a class="dropdown-item"
                (click)="openPlanHistoryDialog(dataItem, planHistoryDialog)">Plan history</a></li>
          </ul>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="MigrationVersionInfo" [locked]="true" [width]="140" title="Migration Version Info">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span *ngIf="isNewPlatformMigrated(dataItem)" class="badge badge-success">New Migrated</span>
          <span *ngIf="!isNewPlatformMigrated(dataItem)" class="badge badge-secondary">Not Migrated</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="FirstName" [locked]="true" [width]="150" title="Doctor Name">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.Salutation ?? '' }} {{ dataItem.FirstName }} {{ dataItem.LastName ?? '' }}
        </ng-template>
      </kendo-grid-column>
      <ng-container *ngIf="screenWidth >= 800">
        <kendo-grid-column field="CompanyName" [locked]="true" [width]="200" title="Clinic Name">
        </kendo-grid-column>
        <kendo-grid-column field="PhoneNumber" [width]="ClientColumnWidth" title="Phone Number">
        </kendo-grid-column>
        <kendo-grid-column field="AppointmentCount" [width]="ClientColumnWidth" title="Appointment Count">
        </kendo-grid-column>
        <kendo-grid-column field="PatientCount" [width]="ClientColumnWidth" title="Patient Count">
        </kendo-grid-column>
        <kendo-grid-column field="ActiveUser" [width]="ClientColumnWidth" title="Total Users">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.ActiveUser }} ({{ dataItem.InActiveUser }})
          </ng-template>
        </kendo-grid-column>
      </ng-container>
      <kendo-grid-column field="Domain" [width]="200" title="Domain">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <a class="domainclass" style="cursor: pointer; " class="dropdown-items"
            (click)="AdminLoginData(dataItem.Id,dataItem.Domain, 'DomainUrl')">{{dataItem.Domain}}</a>
        </ng-template>
      </kendo-grid-column>
      <ng-container *ngIf="screenWidth >= 1085">
        <kendo-grid-column field="Email" [width]="ClientColumnWidth" title="Email">
        </kendo-grid-column>
        <kendo-grid-column field="VerificationCode" [width]="ClientColumnWidth" title="Verification Code">
        </kendo-grid-column>
      </ng-container>

      <ng-container>
        <kendo-grid-column field="Status" title="Status" [width]="ClientColumnWidth" [class]="{ 'text-center': true }">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <span *ngIf="dataItem.Status">
              <kendo-dropdownlist [data]="dropdownValues" [textField]="'text'" [valueField]="'value'"
                [(ngModel)]="dataItem.Status" (selectionChange)="selectedOption($event, dataItem)"
                [ngStyle]="{ 'color': getStatusColor(dataItem.Status) }">
              </kendo-dropdownlist>
            </span>
          </ng-template>
        </kendo-grid-column>
      </ng-container>
      <kendo-grid-column field="IsActive" [width]="ClientColumnWidth" title="Active">
      </kendo-grid-column>
      <kendo-grid-column field="IsEmailVerified" [width]="ClientColumnWidth" title="Email-Verifiy">
      </kendo-grid-column>
      <kendo-grid-column field="CompanyAddress" [width]="ClientColumnWidth" title="Address">
      </kendo-grid-column>
      <kendo-grid-column field="IsTestAccount" [width]="ClientColumnWidth" title="TestAccount">
      </kendo-grid-column>
      <kendo-grid-column field="MigrationStatus" [width]="ClientColumnWidth" title="Status">
      </kendo-grid-column>
      <kendo-grid-column field="CreatedDate" [width]="ClientColumnWidth" title="Created Date">
      </kendo-grid-column>
      <kendo-grid-column field="IPAddress" [width]="ClientColumnWidth" title="IP Address">
      </kendo-grid-column>
      <kendo-grid-column field="IPLocation" [width]="ClientColumnWidth" title="IPLocation">
      </kendo-grid-column>
      <kendo-grid-column field="IsWhatsAppIntegration" [width]="ClientColumnWidth" title="WhatsApp Integration">
      </kendo-grid-column>
      <kendo-grid-column field="Country" [width]="ClientColumnWidth" title="Country">
      </kendo-grid-column>
      <kendo-grid-column field="CompanyName" [width]="ClientColumnWidth" title="CompanyName">
      </kendo-grid-column>
      <kendo-grid-column field="SubscriptionPlanName" [width]="ClientColumnWidth" title="Subscription Plan">
      </kendo-grid-column>
      <kendo-grid-column field="RzpPaymentLinkUrl" [width]="ClientColumnWidth" title="Payment Link">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="d-flex align-items-center">
            <a [href]="dataItem.RzpPaymentLinkUrl" target="_blank"
              [ngStyle]="{'color': dataItem.RzpPaymentLinkStatus === 'expired' ? 'red' : 'inherit'}">
              {{ dataItem.RzpPaymentLinkUrl }}
            </a>
            <mat-icon *ngIf="dataItem.RzpPaymentLinkStatus !== 'expired' && dataItem.RzpPaymentLinkUrl"
              style="cursor: pointer; margin-left: 8px; font-size: 18px;"
              (click)="copyToClipboard(dataItem.RzpPaymentLinkUrl)">
              content_copy
            </mat-icon>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="PlanExpiryDate" [width]="ClientColumnWidth" title="Plan Expiry Date">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.PlanExpiryDate | date: 'dd/MM/YYYY' }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column [width]="250" field="AddOnDetails" title="Add-On">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div *ngFor="let detail of dataItem.AddOnDetails">
            {{ detail.addonUsage ?? 0 }}/{{ detail.AddOnCount }} - {{ detail.TypeName }} - {{ detail.AddOnDate | date:
            'short' }}
          </div>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>
</div>
<ng-template #EditDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="popup-title">
          User Management
        </h5>
        <div class="header-actions">
          <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()">
          </button>
        </div>
      </div>
      <form [formGroup]="formValue" class="diagSave">
        <div class="modal-body">
          <mat-dialog-content>
            <!-- Salutation + Doctor Name -->
            <div class="row">
              <div class="col-3">
                <div class="form-group">
                  <mat-form-field class="w-100 custom-blue">
                    <mat-label>Salutation</mat-label>
                    <mat-select formControlName="Salutation" [panelClass]="'custom-select-panel'"
                      [disableOptionCentering]="true">
                      <mat-option value="Dr.">Dr.</mat-option>
                      <mat-option value="Mr.">Mr.</mat-option>
                      <mat-option value="Mrs.">Mrs.</mat-option>
                      <mat-option value="Ms.">Ms.</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-9">
                <div class="form-group">
                  <mat-form-field class="w-100 custom-blue">
                    <mat-label>Doctor Name</mat-label>
                    <input matInput formControlName="FirstName" maxlength="20" required />
                    <mat-error *ngIf="formValue.controls['FirstName']?.touched &&
                      formValue.controls['FirstName']?.invalid">
                      This field is required.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <!-- Clinic Name -->
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <mat-form-field class="w-100 custom-blue">
                    <mat-label>Clinic Name</mat-label>
                    <input matInput formControlName="CompanyName" />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <!-- Email + Phone -->
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <mat-form-field class="w-100 custom-blue">
                    <mat-label>Email</mat-label>
                    <input matInput type="email" formControlName="Email" placeholder="example@domain.com" maxlength="50"
                      (keyup)="handleBlurEmail($event)" required />
                    <mat-error *ngIf="formValue.controls['Email'].hasError('required')">
                      This field is required.
                    </mat-error>
                    <mat-error *ngIf="formValue.controls['Email'].hasError('pattern')">
                      Follow standard email pattern.
                    </mat-error>
                    <mat-error *ngIf="emailerror">
                      Email already exists, please use a different email.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <mat-form-field class="w-100 custom-blue">
                    <mat-label>Phone Number</mat-label>
                    <input matInput type="number" formControlName="PhoneNumber" (keypress)="keyPress($event)"
                      required />
                    <mat-error *ngIf="formValue.controls['PhoneNumber']?.touched &&
                      formValue.controls['PhoneNumber']?.invalid">
                      This field is required.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <!-- Country -->
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <mat-form-field class="w-100 custom-blue">
                    <mat-label>Country</mat-label>
                    <mat-select formControlName="CurrencyId" [panelClass]="'custom-select-panel'"
                      [disableOptionCentering]="true">
                      <mat-option *ngFor="let item of currencyList" [value]="item.Id">
                        {{ item.CountryName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <!-- Clinic Address -->
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <mat-form-field class="w-100 custom-blue">
                    <mat-label>Clinic Address</mat-label>
                    <input matInput formControlName="CompanyAddress" required />
                    <mat-error *ngIf="formValue.controls['CompanyAddress']?.touched &&
                      formValue.controls['CompanyAddress']?.invalid">
                      This field is required.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <!-- Active + Test Account -->
            <div class="row">
              <div class="col-3">
                <div class="form-group">
                  <label class="text-muted" style="font-size: 12px;" for="IsActive">
                    Active
                  </label>
                  <div class="col-md-2 d-flex align-items-start btn-group" role="group">
                    <input type="radio" class="btn-check" formControlName="IsActive" id="btnradio1" autocomplete="off"
                      value="true" (change)="onStatusChange(true)">
                    <label class="btn btn-outline-primary" for="btnradio1">
                      ON
                    </label>
                    <input type="radio" class="btn-check" formControlName="IsActive" id="btnradio2" autocomplete="off"
                      value="false" (change)="onStatusChange(false)">
                    <label class="btn btn-outline-primary" for="btnradio2">
                      OFF
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label class="text-muted" style="font-size: 12px;" for="TestAccount">
                    Test Account
                  </label>
                  <div class="col-md-2 d-flex align-items-start btn-group" role="group">
                    <input type="radio" class="btn-check" formControlName="IsTestAccount" id="buttonradio1"
                      autocomplete="off" value="true">
                    <label class="btn btn-outline-primary" for="buttonradio1">
                      ON
                    </label>
                    <input type="radio" class="btn-check" formControlName="IsTestAccount" id="buttonradio2"
                      autocomplete="off" value="false">
                    <label class="btn btn-outline-primary" for="buttonradio2">
                      OFF
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </mat-dialog-content>
        </div>
        <mat-dialog-actions align="end">
          <button mat-raised-button style="margin-right: 10px;" type="button" class="btn btn-secondary"
            (click)="closeDialog()">
            Cancel
          </button>
          <button mat-raised-button type="button" class="btn btn-primary" (click)="updateAdmin()"
            [disabled]="isDisableUpdate">
            Update
          </button>
        </mat-dialog-actions>
      </form>
    </div>
  </div>
</ng-template>
<ng-template #deleteDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="popup-title">Delete Confirmation</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeDialog()"></button>
      </div>
      <div class="modal-body">
        <mat-dialog-content>
          <div>Are you sure you want to delete this Client?</div>
          <div>Also your <span style="font-weight: bold;">{{this.domain}}</span> domain will deleted.</div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
          <button mat-raised-button (click)="closeDialog()" type="button" class="btn btn-secondary"
            data-bs-dismiss="modal" tabindex="-1">No</button>
          <button mat-raised-button type="button" (click)="DeleteClientData()" class="btn btn-primary"
            data-bs-toggle="modal" tabindex="-1">Yes</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #migrationDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="popup-title">Migration</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeDialog()"></button>
      </div>
      <div class="modal-body">
        <mat-dialog-content>
          <div>Are you sure you want to Run Migration?</div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
          <button mat-raised-button (click)="closeDialog()" type="button" class="btn btn-secondary"
            data-bs-dismiss="modal" tabindex="-1">No</button>
          <button mat-raised-button type="button" (click)="RunMigrationData()" class="btn btn-primary"
            data-bs-toggle="modal" tabindex="-1">Yes</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #AllmigrationDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="popup-title">Migration</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeDialog()"></button>
      </div>
      <div class="modal-body">
        <mat-dialog-content>
          <div>Are you sure you want to Run All Migration?</div>

        </mat-dialog-content>
        <mat-dialog-actions align="end">
          <button mat-raised-button (click)="closeDialog()" type="button" class="btn btn-secondary"
            data-bs-dismiss="modal" tabindex="-1">No</button>
          <button mat-raised-button type="button" (click)="addMigration()" class="btn btn-primary"
            data-bs-toggle="modal" tabindex="0">Yes</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #mailModal>
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header mail-model-header"
        style="display: flex; align-items: center; justify-content: space-between;">
        <h4 class="popup-title">
          Email For New Features
        </h4>
        <div class="addclosebtn">
          <button style="align-items: center; display: flex; padding: 2px 10px 2px 10px;" type="button"
            class="btn btn-primary addTemplateBtn" (click)="addTemplate(newmodel)">
            Add Template
          </button>

          <div class="header-actions" style="display: flex; gap: 8px;">
            <button mat-icon-button (click)="toggleMaximize()">
              <mat-icon>
                {{ isMaximized ? 'fullscreen_exit' : 'fullscreen' }}
              </mat-icon>
            </button>

            <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()">
            </button>

          </div>

        </div>
      </div>

      <!-- Body -->
      <div class="modal-body mat-dialog-content">

        <mat-dialog-content>

          <div class="row" style="border-bottom: 1px solid #80808075 !important;">

            <!-- Subject -->
            <div class="col-12 col-md-12">

              <mat-form-field class="saveInput lablessfonts mat-form-field-fluid">

                <input type="text" matInput placeholder="Subject" [(ngModel)]="subject" maxlength="100" required />

                <mat-error *ngIf="subject == ''">
                  <span class="error">Subject is required</span>
                </mat-error>

              </mat-form-field>

            </div>

            <!-- Client Select -->
            <div class="col-12 col-md-12 mt-0 mb-3">

              <kendo-floatinglabel text="Select Client(s)"
                style="width: 100%; font-size: inherit; font-weight: 400; font-family: 'Poppins', sans-serif; letter-spacing: normal; color: #7c7c7c;">

                <kendo-multiselect id="test" [kendoDropDownFilter]="filterSettings" [placeholder]="'Select Client'"
                  [autoClose]="false" [(ngModel)]="value" class="searchBox" (valueChange)="valueChange($event)"
                  [data]="clientData" textField="FirstName" valueField="Id" (keyup)="filterFunction($event)">

                  <ng-template kendoMultiSelectHeaderTemplate>

                    <span *ngIf="!isShow" style="margin-left:8px">

                      <kendo-label for="chk">
                        {{ toggleAllText }}
                      </kendo-label>

                      <input style="margin-left:4px" type="checkbox" id="chk" [checked]="isChecked"
                        (click)="onClick()" />

                    </span>

                  </ng-template>

                </kendo-multiselect>

              </kendo-floatinglabel>

            </div>

            <!-- Template Dropdown -->
            <div class="col-12 col-md-12 mt-0 mb-3">

              <kendo-floatinglabel text="Templates" class="drp-template">

                <kendo-dropdownlist [data]="templateData" [(ngModel)]="selectedTemplate" textField="Name"
                  valueField="Id" (valueChange)="onTemplateChange($event)">

                </kendo-dropdownlist>

              </kendo-floatinglabel>

            </div>

            <!-- Template Body -->
            <div class="col-12 col-md-12">

              <label for="templatebody"
                style="font-size: inherit; font-weight: 400; font-family: 'Poppins', sans-serif; letter-spacing: normal;"
                [ngClass]="{'required': !isInputFieldEmpty}">

                Template Body<span> *</span>

              </label>

              <kendo-editor id="templatebody" #editor matInput [(ngModel)]="templateBody" placeholder="Template Body"
                style="height: 250px;" (valueChange)="onInputChange()" required>

                <kendo-toolbar>

                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>

                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>

                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>

                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>

                  <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>

                  <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>

                  <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>

                  <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>

                  <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>

                  <kendo-toolbar-colorpicker kendoEditorBackColor view="gradient">
                  </kendo-toolbar-colorpicker>

                </kendo-toolbar>

              </kendo-editor>

              <mat-error *ngIf="!isInputFieldEmpty">
                <span class="error">Template Body is required</span>
              </mat-error>

            </div>

            <!-- Keywords -->
            <div class="col-12 col-md-12 mt-3">
              <label class="keyWordlbl">KeyWord</label>
            </div>

            <div class="col-12 col-md-12 mt-2" *ngFor="let key of keyWordList">

              <div class="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base" aria-hidden="false">

                <span class="k-chip-content">

                  <span style="padding-bottom: 2px;" class="k-chip-label k-text-ellipsis"
                    (click)="insertTextAtCursor(key.id)">

                    {{ key.id }}

                  </span>

                </span>

              </div>

              <span>&nbsp;:{{ key.text }}</span>

            </div>

          </div>

        </mat-dialog-content>

        <!-- Footer -->
        <mat-dialog-actions align="end">

          <button type="button" mat-raised-button class="btn btn-secondary" (click)="closeDialog()">

            Cancel

          </button>

          <button mat-raised-button type="submit" id="kt_login_signin_submit" class="btn btn-primary"
            (click)="submit(createMailForm)">

            Submit

          </button>

        </mat-dialog-actions>

      </div>
    </div>
  </div>
</ng-template>
<ng-template #mailCountModal>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="popup-title">
          {{ IsReleaseNote ? 'Release Detail' : 'Mail details' }}
        </h4>
      </div>
      <div class="modal-body">
        <mat-dialog-content>
          <div *ngIf="!IsReleaseNote">
            <div>Your <b>{{TotalSendEmails}}</b> email request has been successfully processed.&nbsp;
              <span *ngIf="TotalUnSendEmails != 0">But we were unable to send <b>{{TotalUnSendEmails}}</b> emails due to
                the
                inability to send an email.</span>
            </div>
            <div *ngIf="CompantData.length > 0">
              <kendo-grid [loading]='kendoLoading' [data]="CompantData" [resizable]="true" [reorderable]="true">
                <kendo-grid-column field="FirstName" title="Clinic Name">
                </kendo-grid-column>
                <kendo-grid-column field="Domain" title="Domain">
                </kendo-grid-column>
                <kendo-grid-column field="Email" title="Email">
                </kendo-grid-column>
                <kendo-grid-column field="IsActive" title="Active">
                  <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <span *ngIf="dataItem.IsActive">Yes</span>
                    <span *ngIf="!dataItem.IsActive">No</span>
                  </ng-template>
                </kendo-grid-column>
              </kendo-grid>
            </div>
          </div>
          <div *ngIf="IsReleaseNote">
            Release Note Sent SuccessFully.
          </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
          <button mat-raised-button (click)="closeDialog()" type="button" class="btn btn-secondary"
            data-bs-dismiss="modal" tabindex="-1">Ok</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #newmodel>
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Header -->
      <div class="modal-header mail-model-header">
        <h4 class="popup-title">
          Email Template
        </h4>
        <div class="addclosebtn">
          <div class="header-actions">
            <button mat-icon-button (click)="toggleMaximize1()">
              <mat-icon>
                {{ isMaximizedEmail ? 'fullscreen_exit' : 'fullscreen' }}
              </mat-icon>
            </button>
            <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()">
            </button>
          </div>
        </div>
      </div>

      <!-- Body -->
      <div class="modal-body mat-dialog-content">
        <mat-dialog-content class="matwidth">
          <div class="row mb-3" style="border-bottom: 1px solid #80808075 !important;">
            <!-- Template Name -->
            <div class="col-12 col-md-12 mb-2">
              <mat-form-field class="nameInput lablessfonts mat-form-field-fluid">
                <input type="text" matInput placeholder="Template Name" [(ngModel)]="Name" maxlength="100" required />
                <mat-error *ngIf="Name == ''">
                  <span class="error">Template Name is required</span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Template Body -->
            <div class="col-12 col-md-12" style="margin-bottom: 10px;">
              <label for="templatebody2"
                style="font-size: inherit; font-weight: 400; font-family: 'Poppins', sans-serif; letter-spacing: normal;"
                [ngClass]="{'required': !isTemplateInputFieldEmpty}">
                Template Body<span> *</span>
              </label>
              <kendo-editor id="templatebody2" matInput [(ngModel)]="Body" placeholder="Template Body"
                style="height: 250px;" (valueChange)="InputChange()" required>
                <kendo-toolbar>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>

                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                    <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-buttongroup>
                    <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
                  </kendo-toolbar-buttongroup>
                  <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
                  <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>
                  <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
                  <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
                  <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
                  <kendo-toolbar-colorpicker kendoEditorBackColor view="gradient">
                  </kendo-toolbar-colorpicker>
                </kendo-toolbar>
              </kendo-editor>
              <mat-error *ngIf="!isTemplateInputFieldEmpty">
                <span class="error">Template Body is required</span>
              </mat-error>
            </div>
          </div>
        </mat-dialog-content>

        <!-- Footer -->
        <mat-dialog-actions align="end">
          <button type="button" mat-raised-button class="btn btn-secondary" (click)="closeDialog()">
            Cancel
          </button>

          <button type="submit" mat-raised-button id="kt_login_signin_submit" class="btn btn-primary"
            (click)="save(addMailForm)">
            Submit
          </button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #addOnDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="margin-bottom:5px">
        <h4 class="popup-title">Manage Add-ons</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeDialog()"></button>
      </div>
      <div class="modal-body">
        <mat-dialog-content>
          <div class="container-fluid">
            <!-- Header Row -->
            <div class="row mb-3 pb-2 border-bottom">
              <div class="col-2 font-weight-bold text-muted">
                Add-on
              </div>
              <div class="col-2 font-weight-bold text-muted text-end">
                Existing
              </div>
              <div class="col-5 font-weight-bold text-muted text-center">
                Quantity
              </div>
              <div class="col-3 font-weight-bold text-muted text-end">
                Price/Unit
              </div>
            </div>

            <!-- Add-on Items -->
            <div class="row mb-2" *ngFor="let item of addOns">
              <div class="col-2 font-weight-bold mt-1">
                {{ item.name == 'Storage' ? 'Storage (GB)' : item.name }}
              </div>
              <div class="col-2 d-flex flex-column align-items-end mt-1">
                {{ item.previousQuantity }}
              </div>
              <div class="col-5">
                <div class="input-group input-group-sm">
                  <button class="btn btn-outline-secondary" type="button" (click)="decrement(item)">-</button>
                  <input type="number" class="form-control text-center" [(ngModel)]="item.quantity" min="0"
                    (keypress)="onlyPositiveNumbers($event)"
                    [readOnly]="item.name === 'Patients' || item.name === 'Storage'" />
                  <button class="btn btn-outline-secondary" type="button" (click)="increment(item)">+</button>
                </div>
              </div>
              <div class="col-3 d-flex flex-column align-items-end">
                <input type="number" class="form-control form-control-sm text-end mb-1" [(ngModel)]="item.price" min="0"
                  (focusout)="setItemPrice($event, item)" />
                <small class="text-muted">
                  ₹ {{ item.id == 3 ? (item.quantity/1000 * item.price) : (item.id == 4 ? item.quantity/100 * item.price
                  : item.quantity * item.price) }}
                </small>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-10 text-end font-weight-bold">
                Total:
              </div>
              <div class="col-2 text-end font-weight-bold">
                ₹ {{ getAddOnTotal() }}
              </div>
            </div>
          </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
          <button mat-raised-button (click)="closeDialog()" style="margin-right: 10px;" type="button"
            class="btn btn-secondary" data-bs-dismiss="modal" tabindex="-1">Cancel</button>
          <button mat-raised-button type="button" (click)="submitAddOn()" class="btn btn-primary" data-bs-toggle="modal"
            tabindex="-1">Save</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #changePlanDialog>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header plan-header" style="margin-bottom:10px">
        <h4 class="popup-title ">Change Subscription</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()"></button>
      </div>

      <div class="toggle-container d-flex justify-content-md-end">
        <span class="toggle-text">Monthly</span>
        <mat-slide-toggle class="custom-toggle" [(ngModel)]="isPlanYearly"
          (change)="onPlanToggle($event)"></mat-slide-toggle>
        <span class="toggle-text">Yearly</span>
        <mat-form-field class="currency-dropdown" appearance="outline">
          <mat-select [(ngModel)]="selectedCurrencyId" (selectionChange)="onCurrencyChange($event)"
            placeholder="Currency" [panelClass]="'custom-select-panel-outline'" [disableOptionCentering]="true">
            <mat-option *ngFor="let currency of currencyMap" [value]="currency.Id">
              {{ currency.CurrencyCode }} ({{ currency.CurrencySymbol }})
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="modal-body pt-0">
        <mat-dialog-content>
          <div class="container-fluid">
            <div class="row py-2 border-bottom align-items-center"
              [ngClass]="{ 'current-plan-row': item.id === selectedPlanId }" *ngFor="let item of plans; let i = index">
              <div class="col-12 col-md-3 fw-semibold text-dark">
                {{ item.name }}
              </div>
              <!-- Price -->
              <div class="col-12 col-md-4 fw-semibold text-dark d-flex align-items-center px-0">
                <ng-container *ngIf="item.id == SubscriptionPlanType.BasicPlan; else paidPlan">
                  Free
                </ng-container>
                <ng-template #paidPlan>
                  {{ getCurrencySymbolById(selectedCurrencyId) }}&nbsp;
                  <input type="number" placeholder="Enter amount"
                    [value]="(item.id == SubscriptionPlanType.StandardPlan || item.id == SubscriptionPlanType.PremiumPlan) ? (isPlanYearly ? item.annualPrice : item.monthlyPrice) : ''"
                    class="form-control d-inline-block ms-1 enterprise-input w-50"
                    (change)="updatePlanPrice(i, $event)" />
                  <span class="addOnLabel ms-2" *ngIf="item.isShowAddOn">(Inc. Add-ons)</span>
                </ng-template>
              </div>
              <div class="col-12 col-md-3 fw-semibold text-dark d-flex align-items-center">
                <mat-form-field class="w-100"
                  *ngIf="item.id > selectedPlanId && item.id != SubscriptionPlanType.BasicPlan">
                  <input matInput [matDatepicker]="picker1" placeholder="Expiry Date" readonly [min]="today"
                    (dateChange)="onExpiryDateChange(i, $event)" [value]="expiryDate" />
                  <mat-datepicker-toggle matSuffix [for]="picker1">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2 text-md-end">
                <button class="plan-action-label my-2" [ngClass]="{
                          'degrade': item.id < selectedPlanId,
                          'renew': item.id == selectedPlanId,
                          'upgrade': item.id > selectedPlanId
                        }" (click)="changePlan(item)" (keydown.enter)="changePlan(item)">
                  {{ item.id < selectedPlanId ? 'Degrade' : (item.id==selectedPlanId ? 'Renew' : 'Upgrade' ) }}
                    </button>
              </div>
            </div>
          </div>
        </mat-dialog-content>
      </div>

      <div class="toggle-container d-flex">
        <span class="toggle-text">Attach invoice when sending the plan change email</span>
        <mat-slide-toggle class="custom-toggle" [(ngModel)]="isSendInvoice"></mat-slide-toggle>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #changePLanConfirmationDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="margin-bottom:5px">
        <h4 class="popup-title">Change Subscription</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeConfirmationDialog()"></button>
      </div>
      <div class="modal-body">
        <mat-dialog-content>
          <div *ngIf="selectedRecord.SubscriptionPlanId != newPlan.id">Are you sure you want to switch from the
            {{selectedRecord.SubscriptionPlanName}} to the {{newPlan.name}}?</div>
          <div *ngIf="selectedRecord.SubscriptionPlanId == newPlan.id">Are you sure you want to renew
            {{selectedRecord.SubscriptionPlanName}}?</div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
          <button mat-raised-button (click)="closeConfirmationDialog()" style="margin-right: 10px;" type="button"
            class="btn btn-secondary" tabindex="-1">No</button>
          <button mat-raised-button type="button" (click)="updatePlan()" class="btn btn-primary">Yes</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #MastermigrationDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="margin-bottom:5px">
        <h4 class="popup-title">Migration</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeDialog()"></button>
      </div>
      <div class="modal-body">
        <mat-dialog-content>
          <div>Are you sure you want to Run Master Migration?</div>

        </mat-dialog-content>
        <mat-dialog-actions align="end">
          <button mat-raised-button (click)="closeDialog()" type="button" class="btn btn-secondary"
            data-bs-dismiss="modal" tabindex="-1">No</button>
          <button mat-raised-button type="button" (click)="addMasterMigration()" class="btn btn-primary"
            data-bs-toggle="modal" tabindex="-1">Yes</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #whatsappDialog>
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Header -->
      <div class="modal-header">
        <h4 class="popup-title">Enable Whatsapp</h4>

        <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()">
        </button>
      </div>

      <!-- Body -->
      <div class="modal-body">

        <mat-dialog-content>

          <form [formGroup]="whatsappForm">

            <!-- Provider -->
            <div class="form-group mb-3">
              <mat-radio-group formControlName="Provider">
                <mat-radio-button value="Ifour" class="me-3">
                  IFour (Free)
                </mat-radio-button>

                <mat-radio-button value="SmsIdea">
                  Sms Idea (Paid)
                </mat-radio-button>
              </mat-radio-group>
            </div>

            <!-- Instance Key -->
            <div class="form-group" *ngIf="whatsappForm.get('Provider')?.value === 'SmsIdea'">

              <mat-form-field class="example-full-width saveInput">

                <mat-label>Instance Key</mat-label>

                <input matInput formControlName="InstanceKey" placeholder="Enter Instance Key" required />

                <mat-error *ngIf="
                    (whatsappForm.get('InstanceKey')?.touched || isWhatsappSubmitted) &&
                    whatsappForm.get('InstanceKey')?.invalid">

                  This field is required.

                </mat-error>

              </mat-form-field>
            </div>

            <!-- Expiry Date -->
            <div class="form-group">
              <mat-form-field class="example-full-width saveInput">

                <mat-label>Expiry Date</mat-label>

                <input matInput [matDatepicker]="picker" formControlName="ExpiryDate" [min]="today"
                  placeholder="Expiry date" required readonly (click)="picker.open()" />

                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="
                    (whatsappForm.get('ExpiryDate')?.touched || isWhatsappSubmitted) &&
                    whatsappForm.get('ExpiryDate')?.invalid">
                  Please select an expiry date.
                </mat-error>
              </mat-form-field>
            </div>
            <!-- Amount -->
            <div class="form-group">
              <mat-form-field class="example-full-width saveInput">
                <mat-label>Amount</mat-label>
                <input matInput type="number" formControlName="Amount" placeholder="Enter Amount" required />
                <mat-error *ngIf="
                    (whatsappForm.get('Amount')?.touched || isWhatsappSubmitted) &&
                    whatsappForm.get('Amount')?.invalid">
                  Please enter a valid amount.
                </mat-error>
              </mat-form-field>
            </div>
            <!-- Location Type -->
            <div class="form-group mb-3">
              <label for="locationtypes" class="text-muted" style="font-size: 15px;">
                Location Type
              </label>
              <mat-radio-group formControlName="IsGloble" class="d-flex">
                <mat-radio-button [value]="true" class="me-3">
                  Global
                </mat-radio-button>
                <mat-radio-button [value]="false">
                  Location-wise
                </mat-radio-button>
              </mat-radio-group>
            </div>

            <!-- Location -->
            <div class="form-group" *ngIf="whatsappForm.get('IsGloble')?.value === false">
              <mat-form-field class="example-full-width saveInput">
                <mat-label>Location</mat-label>
                <mat-select formControlName="LocationId" [panelClass]="'custom-select-panel'"
                  [disableOptionCentering]="true" required>
                  <mat-option *ngFor="let item of locationList" [value]="item.Id">
                    {{ item.Name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="
                    whatsappForm.get('LocationId')?.touched &&
                    whatsappForm.get('LocationId')?.invalid">
                  Please select a location.
                </mat-error>
              </mat-form-field>
            </div>
          </form>
        </mat-dialog-content>

        <!-- Footer -->
        <mat-dialog-actions align="end">
          <button mat-raised-button (click)="closeDialog()" type="button" class="btn btn-secondary"
            tabindex="-1">Cancel</button>
          <button mat-raised-button type="button" class="btn btn-primary"
            (click)="addWhatsappInstance()">Submit</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #changeResetPasswordDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header">
        <h4 class="popup-title">Reset Password</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeDialog()">
        </button>
      </div>
      <!-- Body -->
      <div class="modal-body">
        <mat-dialog-content>
          <form class="kt-form" [formGroup]="form" autocomplete="off">
            <!-- New Password -->
            <div class="form-group">
              <mat-form-field class="example-full-width saveInput">
                <mat-label>New Password</mat-label>
                <input matInput [type]="hideNewPassword ? 'password' : 'text'" formControlName="NewPassword"
                  autocomplete="off" minlength="6" required />
                <button mat-icon-button matSuffix type="button" (click)="toggleNewPasswordVisibility()">
                  <mat-icon>
                    {{ hideNewPassword ? 'visibility_off' : 'visibility' }}
                  </mat-icon>
                </button>
                <mat-error *ngIf="isControlHasError('NewPassword','required')">
                  This field is required
                </mat-error>
                <mat-error *ngIf="isControlHasError('NewPassword','minlength')">
                  Password must be at least 6 characters
                </mat-error>
              </mat-form-field>
            </div>
            <!-- Confirm Password -->
            <div class="form-group">
              <mat-form-field class="example-full-width saveInput">
                <mat-label>Confirm Password</mat-label>
                <input matInput [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="ConfirmPassword"
                  autocomplete="off" minlength="6" required />
                <button mat-icon-button matSuffix type="button" (click)="toggleConfirmPasswordVisibility()">
                  <mat-icon>
                    {{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}
                  </mat-icon>
                </button>
                <mat-error *ngIf="isControlHasError('ConfirmPassword','required')">
                  This field is required
                </mat-error>
                <mat-error *ngIf="isControlHasError('ConfirmPassword','minlength')">
                  Password must be at least 6 characters
                </mat-error>
                <mat-error *ngIf="form.get('ConfirmPassword')?.hasError('matching')">
                  Passwords do not match
                </mat-error>
              </mat-form-field>
            </div>
          </form>

        </mat-dialog-content>
        <mat-dialog-actions align="end">
          <button mat-raised-button (click)="closeDialog()" type="button" class="btn btn-secondary"
            tabindex="-1">Cancel</button>
          <button mat-raised-button type="button" class="btn btn-primary" (click)="submitResetForm()">Save</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #planLimitDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header">
        <h4 class="popup-title">Plan Limit</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()">
        </button>
      </div>
      <!-- Body -->
      <div class="modal-body">
        <mat-dialog-content>
          <form class="kt-form" [formGroup]="planLimitForm" autocomplete="off">
            <!-- Service Item -->
            <div class="form-group">
              <mat-form-field class="example-full-width saveInput">
                <mat-label>Service Item</mat-label>
                <input matInput type="number" formControlName="ServiceItem" autocomplete="off" required />
                <mat-error *ngIf="
                  (planLimitForm.controls['ServiceItem'].hasError('required') &&
                  planLimitForm.controls['ServiceItem'].touched) ||
                  planLimitForm.controls['ServiceItem'].untouched">
                  This field is required
                </mat-error>
              </mat-form-field>
            </div>
            <!-- Patient Custom Field -->
            <div class="form-group">
              <mat-form-field class="example-full-width saveInput">
                <mat-label>Patient Custom Field</mat-label>
                <input matInput type="number" formControlName="PatientCustomField" autocomplete="off" required />
                <mat-error *ngIf="
                  (planLimitForm.controls['PatientCustomField'].hasError('required') &&
                  planLimitForm.controls['PatientCustomField'].touched) ||
                  planLimitForm.controls['PatientCustomField'].untouched">
                  This field is required
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Reference -->
            <div class="form-group">
              <mat-form-field class="example-full-width saveInput">
                <mat-label>Reference</mat-label>
                <input matInput type="number" formControlName="Reference" autocomplete="off" required />
                <mat-error *ngIf="
                  (planLimitForm.controls['Reference'].hasError('required') &&
                  planLimitForm.controls['Reference'].touched) ||
                  planLimitForm.controls['Reference'].untouched">
                  This field is required
                </mat-error>
              </mat-form-field>
            </div>
          </form>
        </mat-dialog-content>
        <!-- Footer -->
        <mat-dialog-actions align="end">
          <button mat-raised-button (click)="closeDialog()" type="button" class="btn btn-secondary"
            tabindex="-1">Cancel</button>
          <button mat-raised-button type="button" class="btn btn-primary" (click)="updatePlanLimit()">Update</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #creditLimitDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="popup-title">Credit Limit</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
      </div>
      <div class="modal-body">
        <mat-dialog-content>
          <div class="d-flex justify-content-center mb-4 mt-2">
            <div class="text-center p-3 remaining-credit-container">
              <div class="remaining-credit-label">Remaining Credit</div>
              <div class="remaining-credit-value">{{ remainingCreditLimit || 0 }}</div>
            </div>
          </div>

          <form class="kt-form" [formGroup]="creditLimitForm" autocomplete="off">
            <div class="form-group mb-2">
              <mat-form-field class="example-full-width custom-blue">
                <mat-label>Credit Limit</mat-label>
                <input matInput type="number" formControlName="CreditLimit" autocomplete="off" required min="0"
                  (keypress)="onlyDigits($event)" />
                <mat-error *ngIf=" (creditLimitForm.controls['CreditLimit'].hasError('required') &&  creditLimitForm.controls['CreditLimit'].touched) ||
                                                  creditLimitForm.controls['CreditLimit'].untouched">
                  This field is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="mb-4 mt-3">
              <div class="d-flex align-items-center mb-2 credit-info-container">
                <mat-icon class="credit-info-icon">info</mat-icon>
                <span>This amount will be added to the remaining credit.</span>
              </div>
              <div class="credit-divider"></div>
              <div class="new-credit-text">
                New remaining credit <i class="credit-update-italic">after update:</i>
                <span class="new-credit-value">
                  {{ (remainingCreditLimit || 0) + (creditLimitForm.get('CreditLimit')?.value || 0) }}
                </span>
              </div>
            </div>
          </form>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
          <button mat-raised-button (click)="close()" type="button" class="btn btn-secondary cancel-btn-margin"
            tabindex="-1">Cancel</button>
          <button mat-raised-button type="button" (click)="updateCreditLimit()" id="kt_login_signin_submit"
            [class.spinner]="loading" [disabled]="loading" class="btn btn-primary">Add Credit</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #creditRuleDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="popup-title">Change Credit Rule</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
      </div>
      <div class="modal-body">
        <mat-dialog-content>
          <form [formGroup]="creditRuleForm" class="kt-form">
            <div formArrayName="rules" class="credit-rule-scroll">
              <div class="row mb-2" *ngFor="let rule of ruleControls.controls; let i = index" [formGroupName]="i">
                <div class="col-8">
                  <label class="form-label mb-1">{{ rule.get('Name')?.value }}</label>
                </div>
                <div class="col-4">
                  <input matInput type="number" class="form-control" formControlName="CreditValue" min="0"
                    (keypress)="onlyDigits($event)" />
                </div>
              </div>
            </div>
          </form>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
          <button mat-raised-button (click)="close()" type="button" class="btn btn-secondary"
            style="margin-right: 10px;" tabindex="-1">Cancel</button>
          <button mat-raised-button type="button" (click)="UpdateMality()" [class.spinner]="loading"
            [disabled]="loading" class="btn btn-primary">Save</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #autoRenewDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="titletoptables">Cancel Confirmation</h3>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeDialog()"></button>
      </div>
      <div class="modal-body">
        <mat-dialog-content>
          <div>Are you sure you want to disable Auto-Renew?</div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
          <button mat-raised-button (click)="closeDialog()" type="button" class="btn btn-secondary"
            data-bs-dismiss="modal" tabindex="-2">No</button>
          <button mat-raised-button type="button" (click)="cancelAutoRenew()" class="btn btn-primary"
            data-bs-toggle="modal" tabindex="-1">Yes</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #planHistoryDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="popup-title">Plan History</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeDialog()"></button>
      </div>
      <div class="modal-body">
        <mat-dialog-content>
          <!-- SUBSCRIPTION PLAN TAB -->
          <div class="timeline-container mt-3">
            <!-- CURRENT PLAN -->
            <div class="timeline-item active-timeline-item">
              <div class="timeline-dot currentplan">
                <img src="../../assets/image/backlog-history.png" alt="Current" class="timeline-logo" />
              </div>

              <div class="timeline-content">
                <h4 class="plan-status status-activated mb-2">Active Plan</h4>
                <div class="plan-card active-plan-card p-0">
                  <div class="plan-left-content p-4" *ngIf="currentPlan">
                    <div class="plan-header mb-4 d-flex justify-content-between align-items-center">
                      <div class="meta-item">
                        <span class="meta-label">Plan Name</span>
                        <h3 class="plan-name mb-0">{{ currentPlan?.PlanName || 'Subscription Plan' }}</h3>
                      </div>
                      <div class="plan-remaining" *ngIf="currentPlan?.daysRemaining">
                        <img src="../../assets/image/clock.png" class="hourglass-icon" alt="Remaining" />
                        {{ currentPlan.daysRemaining }} days remaining
                      </div>
                      <div class="plan-remaining" *ngIf="currentPlan?.daysRemaining === 0">
                        <img src="../../assets/image/clock.png" class="hourglass-icon" alt="Expiring Today" />
                        Expiring Today
                      </div>
                    </div>
                    <div class="plan-meta-grid">
                      <div class="meta-item">
                        <span class="meta-label">Activated on</span>
                        <span class="meta-value">{{ currentPlan.Date | date:'dd MMM yyyy, hh:mm a' }}</span>
                      </div>
                      <div class="meta-item">
                        <span class="meta-label">Expiry Date</span>
                        <span class="meta-value">{{ currentPlan.TransactionExpiryDate | date:'dd MMM yyyy' }}</span>
                      </div>
                      <div class="meta-item">
                        <span class="meta-label">Payment Status</span>
                        <span class="meta-value">
                          <span class="status-pill" [ngClass]="currentPlan.TransactionStatus ? 'paid' : 'unpaid'"
                            *ngIf="currentPlan.SubscriptionPlanId != 5">
                            {{ currentPlan.TransactionStatus ? 'Paid' : 'Unpaid' }}
                          </span>
                          <span class="status-pill na" *ngIf="currentPlan.SubscriptionPlanId == 5">-</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="p-4" *ngIf="!currentPlan">
                    <div class="d-flex justify-content-between align-items-center">
                      <h3 class="plan-name mb-0">No Active Plan</h3>
                    </div>
                  </div>
                  <!-- Bottom Add-ons section -->
                  <div class="plan-right-content border-top p-3">
                    <div class="d-flex align-items-center">
                      <h5 class="section-title mb-0 me-4">Add-On</h5>
                      <div class="addon-list">
                        <div class="addon-row" *ngFor="let addon of currentPlan?.addOns">
                          <span class="addon-name">{{ addon.TypeName }}</span>
                          <span class="addon-count-badge">{{ addon.addonUsage || 0 }}/{{ addon.AddOnCount }}</span>
                        </div>
                        <div class="addon-row"
                          *ngIf="currentPlan?.whatsappStatus === 'Active' || currentPlan?.whatsappStatus === 'Expired'">
                          <span class="addon-name">WhatsApp</span>
                          <span class="status-pill"
                            [ngClass]="{'whatsapp': currentPlan?.whatsappStatus === 'Active', 'na': currentPlan?.whatsappStatus === 'Expired'}">
                            {{ currentPlan?.whatsappStatus }}
                          </span>
                          <span class="expiry-date-text" *ngIf="currentPlan?.whatsappStatus === 'Active'">
                            <img src="../../assets/image/clock.png" class="hourglass-icon" alt="clock" />
                            Till {{ currentPlan?.whatsAppExpiryDate | date:DateFormat }}
                          </span>
                        </div>
                        <div class="addon-row" *ngIf="isAIEnabled">
                          <span class="addon-name">AI Chatbot</span>
                          <span class="status-pill Chatbot">
                            Active
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- PREVIOUS PLANS -->
            <div class="timeline-item" *ngFor="let plan of previousPlan">
              <div class="timeline-dot previousplan">
                <img src="../../assets/image/backlog-history.png" alt="Logo" class="timeline-logo" />
              </div>

              <div class="timeline-content">
                <h4 class="plan-status status-expired mb-2">Expired Plan</h4>
                <div class="plan-card expired-plan-card p-0">
                  <div class="plan-left-content p-4">
                    <div class="plan-header mb-4">
                      <div class="meta-item">
                        <span class="meta-label">Plan Name</span>
                        <h3 class="plan-name mb-0">{{ plan.PlanName || '-' }}</h3>
                      </div>
                    </div>

                    <div class="plan-meta-grid">
                      <div class="meta-item">
                        <span class="meta-label">Activated on</span>
                        <span class="meta-value">{{ plan.Date | date:'dd MMM yyyy, hh:mm a' }}</span>
                      </div>
                      <div class="meta-item">
                        <span class="meta-label">Expired Date</span>
                        <span class="meta-value">{{ plan.TransactionExpiryDate | date:'dd MMM yyyy' }}</span>
                      </div>
                      <div class="meta-item">
                        <span class="meta-label">Payment Status</span>
                        <span class="meta-value">
                          <span class="status-pill" [ngClass]="plan.TransactionStatus ? 'paid' : 'unpaid'"
                            *ngIf="plan.SubscriptionPlanId != 5">
                            {{ plan.TransactionStatus ? 'Paid' : 'Unpaid' }}
                          </span>
                          <span class="status-pill na" *ngIf="plan.SubscriptionPlanId == 5">-</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Bottom Add-ons section -->
                  <div class="plan-right-content border-top p-3"
                    *ngIf="plan?.addOns?.length > 0 || (plan?.whatsappStatus === 'Active' || plan?.whatsappStatus === 'Expired')">
                    <div class="d-flex align-items-center">
                      <h5 class="section-title mb-0 me-4">Add-On</h5>
                      <div class="addon-list">
                        <div class="addon-row" *ngFor="let addon of plan?.addOns">
                          <span class="addon-name">{{ addon.TypeName }}</span>
                          <span class="addon-count-badge">{{ addon.addonUsage || 0 }}/{{ addon.AddOnCount }}</span>
                        </div>
                        <div class="addon-row"
                          *ngIf="plan.whatsappStatus === 'Active' || plan.whatsappStatus === 'Expired'">
                          <span class="addon-name">WhatsApp</span>
                          <span class="status-pill"
                            [ngClass]="{'whatsapp': plan.whatsappStatus === 'Active', 'na': plan.whatsappStatus === 'Expired'}">
                            {{ plan.whatsappStatus }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-dialog-content>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #aiAssistantDialog>
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header">
        <h4 class="popup-title">Enable AI Assistant</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeDialog()">
        </button>
      </div>
      <!-- Body -->
      <div class="modal-body">
        <mat-dialog-content>
          <div class="d-flex align-items-center justify-content-between mb-2 mt-2">
            <span class="text-muted">
              Allows users to access the AI Assistant&nbsp;&nbsp;
            </span>
            <mat-slide-toggle class="custom-toggle" [(ngModel)]="isAIEnabled">
              {{ isAIEnabled ? 'ON' : 'OFF' }}
            </mat-slide-toggle>
          </div>
        </mat-dialog-content>
        <!-- Footer -->
        <mat-dialog-actions align="end">
          <button mat-raised-button (click)="closeDialog()" type="button" class="btn btn-secondary"
            tabindex="-1">Cancel</button>
          <button mat-raised-button type="button" class="btn btn-primary"
            (click)="updateAIAssistantStatus()">Update</button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>